function ManifoldLogo({
  height = 32,
  width = 32,
  fill = 'white',
}: {
  height?: number;
  width?: number;
  fill?: string;
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none">
      <path
        d="M22.5541 16.3235C21.6169 10.5094 16.4113 6.36751 10.6093 6.71423C10.3444 6.72859 10.0795 6.75361 9.81463 6.78927C5.87594 7.30119 2.68675 9.78111 1.09975 13.1198C0.887334 11.6095 0.984911 10.0732 1.38681 8.60015C1.78869 7.1271 2.48683 5.74683 3.44063 4.53967C7.35267 -0.451961 14.5574 -1.48558 19.5339 2.23013C20.3436 2.83377 21.064 3.54368 21.6746 4.33971C24.2786 7.73642 24.6558 12.4233 22.5541 16.3235Z"
        fill={fill}
      />
      <path
        d="M19.0094 29.0754C17.3224 30.6189 15.1824 31.6084 12.8898 31.9043C6.67991 32.7122 0.956927 28.3164 0.107259 22.0883C-0.196429 19.9037 0.147976 17.68 1.09968 15.6805C2.68646 12.342 5.87578 9.86208 9.81463 9.35023C10.0795 9.31478 10.3444 9.28974 10.6093 9.27515C7.95367 11.6899 6.49605 15.3382 7.02057 19.1847C7.29304 21.2172 8.11409 23.1426 9.39961 24.7637C11.6565 27.6014 15.2041 29.3036 19.0094 29.0754Z"
        fill={fill}
      />
      <path
        d="M22.1889 27.8367C21.9244 27.8714 21.6594 27.8974 21.3942 27.9111C17.5892 28.1395 14.0415 26.4376 11.785 23.5991C16.1003 24.6562 20.9031 23.1405 23.844 19.3895C24.2569 18.8643 24.6235 18.3056 24.9395 17.7199C27.0416 13.82 26.6647 9.1326 24.0592 5.7356C28.1148 7.04654 31.2784 10.5924 31.8938 15.098C32.7436 21.3262 28.3991 27.0312 22.1889 27.8367Z"
        fill={fill}
      />
    </svg>
  );
}

export default ManifoldLogo;
